import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { tap, throttleTime } from 'rxjs/operators';
/**
 * A directive to prevent double click in buttons
 *
 * See: https://stackoverflow.com/questions/51390476/how-to-prevent-double-click-in-angular
 */
@Directive({
  selector: '[vfsPreventDoubleClick]'
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {
  @Input()
  throttleTime = 500;

  @Input()
  throttledLink = null;

  @Output()
  throttledClick = new EventEmitter();

  private clicks = new Subject();
  private subscription: Subscription;

  /**
   * Constructor
   */
  constructor(private router: Router, protected activatedRoute: ActivatedRoute) {}

  /**
   * Initialize component
   */
  ngOnInit() {
    this.subscription = this.clicks
      .pipe(
        throttleTime(this.throttleTime),
        tap(e => this.emitThrottledClick(e))
      )
      .subscribe();
  }

  /**
   * Emit an action
   *
   * @param e unused
   */
  emitThrottledClick(e) {
    // if the link is defined, just navigate
    if (this.throttledLink) {
      this.router.navigate(this.throttledLink, { relativeTo: this.activatedRoute });
    } else {
      // Emit the click
      this.throttledClick.emit(e);
    }
  }

  /**
   * Destroy the component
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Capture the click event
   *
   * @param event the event
   */
  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
